import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"downloadIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-download\"> <title id=\"icon-download_downloadIconTitle\">Download</title> <path d=\"M12,3 L12,16\" /> <polyline points=\"7 12 12 17 17 12\" /> <path d=\"M20,21 L4,21\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol